import { Circ, Expo, TimelineLite, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import * as PIXI from "pixi.js";
import {Ease} from "../core/Animatable";
import {Container} from "../core/Container";
import {array} from "../core/Reflection";
import {Sprite} from "../core/Sprite";
import { Button, OutlinedButton } from "../gameobjects/Button";
import {AbstractGameState} from "./AbstractGameState";

import { Application } from "../Application";
import * as VO from "../data/VO";
import { Grover } from "../gameobjects/Grover";
import { Oscar } from "../gameobjects/Oscar";
import { OscarCollect } from "../gameobjects/OscarCollect";
import {TrashCollectOutroLayout} from "../layout/TrashCollectOutroLayout";
import { CaptionManager } from "../managers/CaptionManager";

export class TrashCollectOutroScreen extends AbstractGameState {

    public static readonly NAME = "TrashCollectOutroScreen";
    public static visited: boolean = false;

    public readonly bg = this.addChild(new Sprite());
    public readonly oscar = this.addChild(new Oscar());
    public readonly grover = this.addChild(new Grover());
    public readonly skipButton = this.addChild(new Button());
    public readonly homeButton = this.addChild(new OutlinedButton());
    protected analyticsScreenName: string = "4b Trash Blast_Sort Trash Screen";
    protected analyticsRoundName = "Trash Blast";

    public init(pSize: PIXI.Point, pData: {}) {
        TrashCollectOutroLayout.call(this);
        const bagFillAnimation = this.oscar.spine.state.setAnimation(99, "bag-reverse", false);
        bagFillAnimation.timeScale = 0;

        this.skipButton.onClick.add(() => {
            TrashCollectOutroScreen.visited = true;
            this.gotoNextState("TrashReturnScreen");
        });
        this.homeButton.onClick.add(() => {
            this.trackEvent("gameMenuClick", {buttonName: "Home"});
            this.gotoNextState("MainMenu");
        });
        this.homeButton.clickSfx = "buttonclick";
        this.skipButton.clickSfx = "buttonclick";

        this.skipButton.visible = false;

        super.init(pSize);
    }

    public animateIn(pOnComplete: () => void) {
        super.animateIn(pOnComplete);
        const bgm = HLF.Application.instance.audio.getAudioTrack("trash_blast_loop", HLF.AudioCategory.BGM) ?? HLF.Application.instance.audio.createAudioTrack("trash_blast_loop", HLF.AudioCategory.BGM);
        if (bgm.isPlaying() === false) {
            bgm.setLooped(true);
            bgm.play();
        }
        Application.instance.voiceover.playVO([...VO.TB_SORTINTRO01], () => {
            this.grover.LookLeft();
            TweenLite.delayedCall(1, () => {
                this.grover.LookRight();
            });
            TweenLite.delayedCall(2, () => {
                this.grover.LookCenter();
            });
            TweenLite.delayedCall(3, () => {
                Application.instance.voiceover.playVO([VO.TB_SORTINTRO01_3, VO.TB_SORTINTRO02, ...VO.TB_SORTINTRO03], () => {
                    TrashCollectOutroScreen.visited = true;
                    this.gotoNextState("TrashReturnScreen");
                });
            });
        });
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
        this.position.set((pSize.x - 1024) / 2, 0);
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
        this.grover.update(pDeltaTime);
        this.oscar.update(pDeltaTime);
    }
}
